import req from '@/utils/index.js'
import url from '@/config/url1.js'
export default {
    data() {
        return {
            selectList: [],//转应收前判断有没有数据
            typeMin: '',//接收付类型
            transCurr: '',//币制
            busIdMin: '',//busid
            information: '', //装箱信息
            intableDataMix: [],
            // cust:'',//委托单位

        };
    },
    methods: {
        //确认币制 在组件函数handleSelectionChange获取selectList数组信息
        confirmCurr(cust) {
            if (this.transCurr) {
                let copyOfSelectList = JSON.parse(JSON.stringify(this.selectList));
                copyOfSelectList.forEach(element => {
                    if (element.currency == 'USD' && this.transCurr == 'VND') {
                        element.unitPrice = element.unitPrice * element.exchangeRate;
                        element.unitPriceWt = element.unitPriceWt * element.exchangeRate;
                        element.total = element.total * element.exchangeRate;
                        element.totalWt = element.totalWt * element.exchangeRate;
                        element.company = cust;

                    } else if (element.currency == 'VND' && this.transCurr == 'USD') {
                        element.unitPrice = Number(element.unitPrice / element.exchangeRate).toFixed(2);
                        element.unitPriceWt = Number(element.unitPriceWt / element.exchangeRate).toFixed(2);
                        element.total = Number(element.total / element.exchangeRate).toFixed(2);
                        element.totalWt = Number(element.totalWt / element.exchangeRate).toFixed(2);
                        element.company = cust;
                    } else if (element.currency == this.transCurr) {
                        element.company = cust;
                    }
                    element.feeType = this.typeMin;
                    element.editing = true;
                    element.currency = this.transCurr;
                    element.finance = 0;
                    const value = localStorage.getItem('name');
                    element.createMan = value;
                    delete element.id;
                });
                const copyOfSelect = JSON.parse(JSON.stringify(copyOfSelectList));
                this.intableDataMix.push(...copyOfSelect);
            } else {
                this.$message.error('请选择要转应收的币制');
            }
            this.$parent.currDialogVisible = false;
        },

        //id获取箱型量信息
        getContainersDesByBusId() {
            if(this.busIdMin !== ''){
                let URL = `${url.getContainersDesByBusId}/${this.busIdMin}`;
                req.get(URL).then(res => {
                    if (res.data.code == 200) {
                        this.information = res.data.data;
                    } else {
                        this.$message.error(res.data.message);
                    }

                });
            }
        },
    },
    computed: {

    },
    created() {

    },
};